import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import { AccountFooter } from '@ifca-root/react-component/src/components/Footer/AccountFooter'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  Button,
  Checkbox,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { isAfter, isBefore, isEqual } from 'date-fns'
import {
  ApprovalStatus,
  useCreateInvoiceAmortisationMutation,
  useGetArInvoicebyAmortItemLazyQuery,
  useGetArInvoiceItembyInvoiceHeaderLazyQuery,
  useGetGenerateAmortisationLazyQuery,
  useLatestOpenPeriodCheckingDateQuery,
  useUpdateArAmortisationMutation,
} from 'generated/graphql'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router'
import * as yup from 'yup'
import '../InvoiceAmortisationDetail/InvoiceAmortisation.scss'
import { InvoiceAmortisationItemForm } from './InvoiceAmortisationItemForm'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import '../responsive-table.css'
interface InvoiceAmortisationFormProps {
  InvoiceID: string
  InvoiceAmortisationItem: InvoiceAmortisationItemFormProps[]
  MasterCOAID: string
}

interface InvoiceAmortisationItemFormProps {
  MasterCOAID: string
}

interface InvoiceOption {
  Description: string
  DocAmt: string
  DocNo: string
  InvoiceID: string
  DebtorName: string
}

export const InvoiceAmortisationForm = (props: any) => {
  const { formMode, type } = props
  let history = useHistory()
  const { CompanyID, AmortisationID }: any = useParams()
  let location = useLocation()
  const editData = location?.state as any
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [docNo, setDocNo] = useState('')
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isErrorCall, setIsErrorCall] = useState<boolean>(false)
  const [dateValidationError, setDateValidationError] = useState('')
  const [selectedItems, setSelectedItems] = useState<{
    [key: number]: boolean
  }>({})
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const ParamsSchema = yup.object().shape({
    InvoiceID: yup.string().required('Invoice No is required'),
  })

  const { handleSubmit, register, errors, control, watch, setValue } = useForm<
    InvoiceAmortisationFormProps
  >({
    defaultValues: {
      // MasterCOAID: editData?.AmortisationItem.${index}.MasterCOAID || '',
      InvoiceID: editData?.InvoiceID || '',
      // ContractStartDate: editData?.ContractStartDate || new Date(),
      // ContractEndDate: editData?.ContractEndDate || new Date(),
      // FirstAmortDate: editData?.FirstAmortDate || new Date(),
    },
    mode: 'all',
    resolver: yupResolver(ParamsSchema),
  })

  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }

  /* -------------------------------------------- */
  /*                    API                       */
  /* -------------------------------------------- */
  const [
    loadARInvoiceByAmortItem,
    {
      loading: ARInvoiceByAmortItemLoading,
      data: { getARInvoicebyAmortItem } = { getARInvoicebyAmortItem: [] },
    },
  ] = useGetArInvoicebyAmortItemLazyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
  })

  const [
    loadGenerateAmortisation,
    {
      loading: generateAmortisationLoading,
      data: { getGenerateAmortisation } = { getGenerateAmortisation: [] },
    },
  ] = useGetGenerateAmortisationLazyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
  })

  const [
    loadgetARInvoiceItembyInvoiceHeader,
    {
      loading: getARInvoiceItembyInvoiceHeaderLoading,
      data: { getARInvoiceItembyInvoiceHeader } = {
        getARInvoiceItembyInvoiceHeader: [],
      },
    },
  ] = useGetArInvoiceItembyInvoiceHeaderLazyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    loadARInvoiceByAmortItem({
      variables: {
        AmortisationID: AmortisationID ?? null,
        CompanyID: CompanyID,
      },
    })
  }, [])

  const [
    createInvoiceAmortisation,
    { loading: createInvoiceAmortisationLoading },
  ] = useCreateInvoiceAmortisationMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      history.push(`/account-receivable/${CompanyID}/invoice-amortisation`)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setOpenSnackBar(true)
    },
  })
  const [
    updateARAmortisation,
    { loading: updateARAmortisationLoading },
  ] = useUpdateArAmortisationMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      history.push(`/account-receivable/${CompanyID}/invoice-amortisation`)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setOpenSnackBar(true)
    },
  })

  const {
    loading: openPeriodCheckDateLoading,
    data: { latestOpenPeriodCheckingDate } = {
      latestOpenPeriodCheckingDate: {} as any,
    },
  } = useLatestOpenPeriodCheckingDateQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onCompleted: () => {
      setDocNo(editData?.Invoice?.DocNo)
    },
  })

  const masterCOAChecking = () => {
    let status = false
    getGenerateAmortisation?.map((el, index) => {
      const keyIn = watch(`InvoiceAmortisationItem.${index}.MasterCOAID`)

      if (keyIn === undefined) {
        status = true
      }
    })
    return status
  }

  /* -------------------------------------------- */
  /*                    SUBMIT                    */
  /* -------------------------------------------- */

  const onSubmit = (data, submitMode) => {
    if (!loading) {
      setLoading(true)
      let InvoiceAmortisationItem = watch('InvoiceAmortisationItem')
      let InvoiceItems = watch('InvoiceItems')

      const missingMasterCOA = data.InvoiceAmortisationItem?.some(
        item => !item.MasterCOAID || item.MasterCOAID === ''
      )

      if (missingMasterCOA) {
        setIsErrorCall(true)
        setSnackBarMsg('GL Account Code is required for all items')
        setOpenSnackBar(true)
        setLoading(false)
        return
      }
      setIsErrorCall(false)

      const validItems = getGenerateAmortisation
        ?.map((generatedItem: any, genIndex) => {
          const invoiceItemIndex = getARInvoiceItembyInvoiceHeader?.findIndex(
            (item: any) => item.InvoiceItemID === generatedItem.InvoiceItemID
          )

          if (invoiceItemIndex === -1 || !selectedItems[invoiceItemIndex]) {
            return null
          }

          const formData = InvoiceAmortisationItem?.[genIndex]
          const invoiceItemData = InvoiceItems?.[invoiceItemIndex]

          return {
            debitMasterCoaID: generatedItem.DebitMasterCOAID,
            creditMasterCoaID:
              formData?.MasterCOAID ??
              editData?.AmortisationItem?.find(
                (item: any) =>
                  item.InvoiceItemID === generatedItem.InvoiceItemID
              )?.creditMasterCoaID,
            ...(generatedItem.InvoiceItemID
              ? { InvoiceItemID: generatedItem.InvoiceItemID }
              : {}),
            ContractStartDate: formatDashDate(
              new Date(invoiceItemData?.ContractStartDate)?.toISOString()
            ),
            ContractEndDate: formatDashDate(
              new Date(invoiceItemData?.ContractEndDate)?.toISOString()
            ),
            FirstAmortDate: formatDashDate(
              new Date(invoiceItemData?.FirstAmortDate)?.toISOString()
            ),
            Month: invoiceItemData?.Month || 1,
            AmortisationItemDetails: generatedItem?.AmortisationItemDetails
              ? generatedItem.AmortisationItemDetails.map((y: any) => ({
                  FYear: y?.FYear,
                  FPeriod: y?.FPeriod,
                  AmortDate: y?.AmortDate,
                  Amount: Number(y?.Amount),
                }))
              : [],
          }
        })
        .filter(Boolean)

      const input = {
        ...(!!AmortisationID ? { AmortisationID: AmortisationID } : null),
        InvoiceID: data.InvoiceID,
        ApprovalStatus:
          submitMode === 'draft'
            ? ApprovalStatus.Active
            : ApprovalStatus.Submit,
        CompanyID: CompanyID,
        InvoiceAmortisationItems: validItems,
      }

      if (mode === 'add') {
        createInvoiceAmortisation({
          variables: {
            input,
          },
        })
      } else {
        updateARAmortisation({
          variables: {
            AmortisationID: AmortisationID,
            input,
          },
        })
      }
    }
  }

  const isRowDisabled = (item: any) => {
    if (
      item?.AmortisationDetails?.[0]?.AmortisationID &&
      editData?.AmortisationID &&
      item.AmortisationDetails?.[0]?.AmortisationID !==
        editData.AmortisationID &&
      item?.AmortisationDetails?.[0]?.AmortisationApprovalStatus !== 'CANCELLED'
    ) {
      return true
    }

    if (
      (mode === 'edit' &&
        item?.AmortisationDetails?.[0]?.AmortisationApprovalStatus ===
          'ACTIVE' &&
        item?.AmortisationDetails?.[0]?.AmortisationItemStatus === 'ACTIVE') ||
      (mode === 'edit' &&
        item?.AmortisationDetails?.[0]?.AmortisationApprovalStatus ===
          'REJECTED' &&
        item?.AmortisationDetails?.[0]?.AmortisationItemStatus === 'ACTIVE')
    ) {
      return false
    }

    const disabledApprovalStatuses = [
      'SUBMIT',
      'COMPLETED',
      'REJECTED',
      'ACTIVE',
    ]
    const disabledItemStatuses = ['ACTIVE', 'COMPLETED']

    return (
      disabledApprovalStatuses.includes(
        item?.AmortisationDetails?.[0]?.AmortisationApprovalStatus
      ) &&
      disabledItemStatuses.includes(
        item?.AmortisationDetails?.[0]?.AmortisationItemStatus
      )
    )
  }

  useEffect(() => {
    if (getARInvoiceItembyInvoiceHeader?.length > 0) {
      const timer = setTimeout(() => {
        const initialSelectedItems = {}
        setValue('InvoiceItems', [])
        getARInvoiceItembyInvoiceHeader.forEach((item, index) => {
          const amortDetails = item?.AmortisationDetails?.[0]
          const hasAmortDetails =
            amortDetails &&
            (amortDetails.ContractStartDate ||
              amortDetails.ContractEndDate ||
              amortDetails.FirstAmortDate)
          const contractStartDate = hasAmortDetails
            ? new Date(amortDetails.ContractStartDate)
            : new Date()
          const contractEndDate = hasAmortDetails
            ? new Date(amortDetails.ContractEndDate)
            : new Date()
          const calculatedMonths =
            hasAmortDetails && amortDetails.Month
              ? amortDetails.Month
              : getMonthsBetween(contractStartDate, contractEndDate)
          setValue(`InvoiceItems.${index}.InvoiceItemID`, item?.InvoiceItemID, {
            shouldValidate: false,
            shouldDirty: false,
          })
          setValue(`InvoiceItems.${index}.Month`, calculatedMonths, {
            shouldValidate: false,
            shouldDirty: false,
          })
          setValue(
            `InvoiceItems.${index}.ContractStartDate`,
            contractStartDate,
            {
              shouldValidate: false,
              shouldDirty: false,
            }
          )
          setValue(`InvoiceItems.${index}.ContractEndDate`, contractEndDate, {
            shouldValidate: false,
            shouldDirty: false,
          })
          setValue(
            `InvoiceItems.${index}.FirstAmortDate`,
            hasAmortDetails
              ? new Date(amortDetails.FirstAmortDate)
              : new Date(),
            { shouldValidate: false, shouldDirty: false }
          )

          if (
            item?.AmortisationDetails?.[0]?.AmortisationItemStatus ===
              'ACTIVE' &&
            !isRowDisabled(item) &&
            item?.AmortisationDetails?.[0]?.AmortisationApprovalStatus !==
              'CANCELLED'
          ) {
            initialSelectedItems[index] = true
          }
        })
        setSelectedItems(initialSelectedItems)
      }, 50)

      return () => clearTimeout(timer)
    }
  }, [getARInvoiceItembyInvoiceHeader, setValue])

  const onSubmitGenerate = data => {
    setDateValidationError('')
    const items = data.InvoiceItems || []

    if (!items || items.length === 0) {
      setDateValidationError('No invoice items found')
      return
    }
    const checkedIndices = Object.keys(selectedItems)
      .filter(key => selectedItems[key])
      .map(Number)

    if (checkedIndices.length === 0) {
      setDateValidationError('Please select at least one item to generate')
      return
    }

    for (const i of checkedIndices) {
      const item = items[i]

      if (
        !item.ContractStartDate ||
        !item.ContractEndDate ||
        !item.FirstAmortDate
      ) {
        setDateValidationError(`Item ${i + 1}: Missing required dates`)
        return
      }

      const startDate = new Date(item.ContractStartDate)
      const endDate = new Date(item.ContractEndDate)
      const amortDate = new Date(item.FirstAmortDate)

      if (isAfter(startDate, endDate)) {
        setDateValidationError(
          `Item ${i +
            1}: Contract Start Date cannot be greater than Contract End Date`
        )
        return
      }

      if (isBefore(amortDate, startDate)) {
        setDateValidationError(
          `Item ${i + 1}: First Amort Date cannot less then Contract Start Date`
        )
        return
      }
    }

    const formattedItems = checkedIndices.map(i => {
      const formItem = items[i]
      const actualItem = getARInvoiceItembyInvoiceHeader[i]
      return {
        InvoiceItemID: actualItem?.InvoiceItemID,
        ContractStartDate: formatDashDate(
          new Date(formItem.ContractStartDate)?.toISOString()
        ),
        ContractEndDate: formatDashDate(
          new Date(formItem.ContractEndDate)?.toISOString()
        ),
        AmortDate: formatDashDate(
          new Date(formItem.FirstAmortDate)?.toISOString()
        ),
        Month: (formItem.Month || 1).toString(),
      }
    })

    loadGenerateAmortisation({
      variables: {
        CompanyID: CompanyID,
        InvoiceID: data?.InvoiceID,
        items: formattedItems,
      },
    })
  }

  const InvoiceAmt = getARInvoicebyAmortItem?.find(
    x => x?.InvoiceID === watch(`InvoiceID`)
  )?.TotalBaseAmtAmorItem

  const firstAmortDate = new Date(watch('FirstAmortDate'))
  const contractEndDate = new Date(watch('ContractEndDate'))

  // Calculate the number of months
  const getMonthsBetween = (startDate, endDate) => {
    const start = new Date(startDate)
    const end = new Date(endDate)

    return (
      (end.getFullYear() - start.getFullYear()) * 12 +
      (end.getMonth() - start.getMonth()) +
      1
    )
  }

  const numberOfMonths = getMonthsBetween(firstAmortDate, contractEndDate)

  /* -------------------------------------------- */
  /*                    FOOTER                    */
  /* -------------------------------------------- */
  const draftFooterOption = {
    name: 'Save as Draft',
    onClick: () => {
      setIsErrorCall(true)
      if (masterCOAChecking() === false) {
        handleSubmit(data => onSubmit(data, 'draft'))()
      }
    },
    color: 'primary',
    props: { type: 'submit' },
    disabled:
      getGenerateAmortisation?.length === 0 ||
      getGenerateAmortisation === undefined,
    //   handlePermDisabled({
    //     companyID: CompanyID,
    //     permEnum: AcctPermission.GeneralLedgerJournalProcessingDraft,
    //   })),
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: () => {
      setIsErrorCall(true)
      if (masterCOAChecking() === false) {
        handleSubmit(data => onSubmit(data, 'submit'))()
      }
    },
    color: 'primary',
    props: { type: 'submit' },
    disabled:
      getGenerateAmortisation?.length === 0 ||
      getGenerateAmortisation === undefined,
    //    handlePermDisabled({
    //           companyID: CompanyID,
    //           permEnum:
    //             AcctPermission.GeneralLedgerJournalProcessingCreate ||
    //             AcctPermission.GeneralLedgerJournalProcessingUpdate,
    //         })
    //
  }

  let footerOptions = [draftFooterOption, submitFooterOption]
  useEffect(() => {
    if (editData?.InvoiceID) {
      loadgetARInvoiceItembyInvoiceHeader({
        variables: {
          InvoiceID: editData.InvoiceID,
        },
      })
    }
  }, [editData])

  useEffect(() => {
    if (
      editData &&
      editData?.AmortisationItem &&
      getARInvoiceItembyInvoiceHeader?.length > 0
    ) {
      setTimeout(() => {
        getARInvoiceItembyInvoiceHeader.forEach((invoiceItem, invoiceIndex) => {
          const matchingAmortItem = editData.AmortisationItem.find(
            (amortItem: any) =>
              amortItem?.InvoiceItemID === invoiceItem?.InvoiceItemID
          )

          if (matchingAmortItem) {
            setValue(
              `InvoiceItems.${invoiceIndex}.InvoiceItemID`,
              matchingAmortItem?.InvoiceItemID
            )
            setValue(
              `InvoiceItems.${invoiceIndex}.ContractStartDate`,
              new Date(matchingAmortItem?.ContractStartDate)
            )
            setValue(
              `InvoiceItems.${invoiceIndex}.ContractEndDate`,
              new Date(matchingAmortItem?.ContractEndDate)
            )
            setValue(
              `InvoiceItems.${invoiceIndex}.FirstAmortDate`,
              new Date(matchingAmortItem?.FirstAmortDate)
            )
            setValue(
              `InvoiceItems.${invoiceIndex}.Month`,
              matchingAmortItem?.Month || 1
            )
          } else {
            const amortDetails = invoiceItem?.AmortisationDetails?.[0]
            const hasAmortDetails =
              amortDetails && amortDetails.ContractStartDate

            if (hasAmortDetails) {
              const startDate = new Date(amortDetails.ContractStartDate)
              const endDate = new Date(amortDetails.ContractEndDate)
              const calculatedMonths =
                amortDetails.Month || getMonthsBetween(startDate, endDate)

              setValue(
                `InvoiceItems.${invoiceIndex}.InvoiceItemID`,
                invoiceItem?.InvoiceItemID
              )
              setValue(
                `InvoiceItems.${invoiceIndex}.ContractStartDate`,
                startDate
              )
              setValue(`InvoiceItems.${invoiceIndex}.ContractEndDate`, endDate)
              setValue(
                `InvoiceItems.${invoiceIndex}.FirstAmortDate`,
                new Date(amortDetails.FirstAmortDate)
              )
              setValue(`InvoiceItems.${invoiceIndex}.Month`, calculatedMonths)
            } else {
              setValue(
                `InvoiceItems.${invoiceIndex}.InvoiceItemID`,
                invoiceItem?.InvoiceItemID
              )
              setValue(
                `InvoiceItems.${invoiceIndex}.ContractStartDate`,
                new Date()
              )
              setValue(
                `InvoiceItems.${invoiceIndex}.ContractEndDate`,
                new Date()
              )
              setValue(
                `InvoiceItems.${invoiceIndex}.FirstAmortDate`,
                new Date()
              )
              setValue(`InvoiceItems.${invoiceIndex}.Month`, 1)
            }
          }
        })

        const formattedItems = editData.AmortisationItem.map((item: any) => ({
          InvoiceItemID: item?.InvoiceItemID,
          ContractStartDate: formatDashDate(
            new Date(item?.ContractStartDate)?.toISOString()
          ),
          ContractEndDate: formatDashDate(
            new Date(item?.ContractEndDate)?.toISOString()
          ),
          AmortDate: formatDashDate(
            new Date(item?.FirstAmortDate)?.toISOString()
          ),
          Month: item?.Month?.toString() || '1',
        }))

        loadGenerateAmortisation({
          variables: {
            CompanyID: CompanyID,
            InvoiceID: editData?.InvoiceID,
            items: formattedItems,
          },
        })
      }, 100)
    }
  }, [editData, getARInvoiceItembyInvoiceHeader, setValue])

  useEffect(() => {
    if (getGenerateAmortisation && getGenerateAmortisation.length > 0) {
      getGenerateAmortisation.forEach((item, idx) => {
        const editItem = editData?.AmortisationItem?.find(
          (amortItem: any) => amortItem.InvoiceItemID === item.InvoiceItemID
        )

        if (editItem?.creditMasterCoaID) {
          setValue(
            `InvoiceAmortisationItem.${idx}.MasterCOAID`,
            editItem.creditMasterCoaID,
            { shouldValidate: false }
          )
        } else {
          setValue(`InvoiceAmortisationItem.${idx}.MasterCOAID`, '', {
            shouldValidate: false,
          })
        }
      })
    }
  }, [getGenerateAmortisation, setValue, editData])

  return (
    <>
      {openPeriodCheckDateLoading && <Loading />}
      {ARInvoiceByAmortItemLoading && <Loading />}
      {generateAmortisationLoading && <Loading />}
      {updateARAmortisationLoading && <Loading />}
      {createInvoiceAmortisationLoading && <Loading />}
      {getARInvoiceItembyInvoiceHeaderLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() =>
          history.push(`/account-receivable/${CompanyID}/invoice-amortisation`)
        }
        smTitle={'Account Receivable'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Submenu' },
          { name: 'Invoice Amortisation', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              formMode === 'add'
                ? 'New'
                : formMode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />
      <ContentWrapper float>
        <CardContents>
          {!ARInvoiceByAmortItemLoading && (
            <Controller
              render={({ value, onChange }) => {
                const options: InvoiceOption[] = getARInvoicebyAmortItem
                const defVal = getARInvoicebyAmortItem?.filter(
                  x => x?.InvoiceID === editData?.InvoiceID
                )[0]

                return (
                  <Autocomplete
                    options={options || []}
                    getOptionLabel={(option: any) =>
                      `${option.DocNo || ''} | ${option.DebtorName || ''}`
                    }
                    fullWidth
                    onChange={(value, newValue: any) => {
                      setDocNo(newValue?.DocNo)
                      setValue('InvoiceID', newValue?.InvoiceID)
                      loadgetARInvoiceItembyInvoiceHeader({
                        variables: {
                          InvoiceID: newValue?.InvoiceID ?? null,
                        },
                      })
                    }}
                    defaultValue={defVal}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        helperText={errors?.InvoiceID?.message}
                        error={!!errors?.InvoiceID}
                        label="Invoice No"
                        style={{ width: '100%' }}
                        margin="normal"
                        required
                      />
                    )}
                  />
                )
              }}
              label="Invoice No"
              name="InvoiceID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="normal"
              ref={register}
              helperText={errors?.InvoiceID?.message}
              error={errors?.InvoiceID ? true : false}
              required
              defaultValue={editData ? editData?.InvoiceID : ''}
            />
          )}

          {!!watch(`InvoiceID`) && getARInvoiceItembyInvoiceHeader?.length > 0 && (
            <div className="content-wrap full">
              <TableContainer component={Paper} className="table-container">
                <Table className="invoice-table">
                  <TableHead>
                    <TableRow className="table-header-row">
                      <TableCell
                        className="responsive-table-header table-header-cell"
                        style={{ width: '50px' }}
                      >
                        Select
                      </TableCell>
                      <TableCell className="responsive-table-header item-name-cell table-header-cell">
                        Item
                      </TableCell>
                      <TableCell className="responsive-table-header date-cell table-header-cell">
                        Contract Start Date
                      </TableCell>
                      <TableCell className="responsive-table-header date-cell table-header-cell">
                        Contract End Date
                      </TableCell>
                      <TableCell className="responsive-table-header date-cell table-header-cell">
                        First Amort Date
                      </TableCell>
                      <TableCell className="responsive-table-header months-cell table-header-cell">
                        No. of Months
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getARInvoiceItembyInvoiceHeader?.map((item, index) => {
                      const itemContractStartDate = watch(
                        `InvoiceItems.${index}.ContractStartDate`
                      )
                      const itemContractEndDate = watch(
                        `InvoiceItems.${index}.ContractEndDate`
                      )

                      const itemMonths =
                        itemContractStartDate && itemContractEndDate
                          ? getMonthsBetween(
                              itemContractStartDate,
                              itemContractEndDate
                            )
                          : 1

                      const disabled = isRowDisabled(item)

                      return (
                        <TableRow
                          key={index}
                          className="table-row"
                          style={{
                            backgroundColor: disabled ? '#f5f5f5' : 'inherit',
                            opacity: disabled ? 0.6 : 1,
                          }}
                        >
                          <TableCell
                            className="responsive-table-cell"
                            style={{ textAlign: 'center' }}
                          >
                            <Checkbox
                              checked={selectedItems[index] || false}
                              onChange={e => {
                                setSelectedItems({
                                  ...selectedItems,
                                  [index]: e.target.checked,
                                })
                              }}
                              color="primary"
                              disabled={disabled}
                            />
                          </TableCell>

                          <TableCell className="responsive-table-cell item-name-cell">
                            {item?.Description ||
                              item?.ItemName ||
                              `Item ${index + 1}`}

                            <Controller
                              name={`InvoiceItems.${index}.InvoiceItemID`}
                              control={control}
                              defaultValue={item?.InvoiceItemID || ''}
                              render={({ value }) => {
                                return (
                                  <input
                                    type="hidden"
                                    value={item?.InvoiceItemID || ''}
                                  />
                                )
                              }}
                            />

                            <Controller
                              name={`InvoiceItems.${index}.Month`}
                              control={control}
                              defaultValue={1}
                              render={({ value }) => (
                                <input type="hidden" value={value || 1} />
                              )}
                            />
                          </TableCell>
                          <TableCell className="responsive-table-cell date-cell">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Controller
                                name={`InvoiceItems.${index}.ContractStartDate`}
                                control={control}
                                defaultValue={new Date()}
                                render={({ value, onChange }) => (
                                  <KeyboardDatePicker
                                    format="dd/MM/yyyy"
                                    value={value || new Date()}
                                    onChange={date => {
                                      onChange(date)
                                      const endDate = watch(
                                        `InvoiceItems.${index}.ContractEndDate`
                                      )
                                      if (date && endDate) {
                                        const months = getMonthsBetween(
                                          date,
                                          endDate
                                        )
                                        setValue(
                                          `InvoiceItems.${index}.Month`,
                                          months
                                        )
                                      }
                                    }}
                                    margin="none"
                                    allowKeyboardControl
                                    KeyboardButtonProps={{
                                      'aria-label': 'change date',
                                    }}
                                    showTodayButton
                                    fullWidth
                                    minDate={
                                      new Date(
                                        latestOpenPeriodCheckingDate?.StartDate
                                      )
                                    }
                                    maxDate={
                                      new Date(
                                        latestOpenPeriodCheckingDate?.EndDate
                                      )
                                    }
                                    InputProps={{
                                      className: 'date-input',
                                    }}
                                    disabled={disabled}
                                  />
                                )}
                              />
                            </MuiPickersUtilsProvider>
                          </TableCell>
                          <TableCell className="responsive-table-cell date-cell">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Controller
                                name={`InvoiceItems.${index}.ContractEndDate`}
                                control={control}
                                defaultValue={new Date()}
                                render={({ value, onChange }) => (
                                  <KeyboardDatePicker
                                    format="dd/MM/yyyy"
                                    value={value || new Date()}
                                    onChange={date => {
                                      onChange(date)
                                      const startDate = watch(
                                        `InvoiceItems.${index}.ContractStartDate`
                                      )
                                      if (startDate && date) {
                                        const months = getMonthsBetween(
                                          startDate,
                                          date
                                        )
                                        setValue(
                                          `InvoiceItems.${index}.Month`,
                                          months
                                        )
                                      }
                                    }}
                                    margin="none"
                                    allowKeyboardControl
                                    KeyboardButtonProps={{
                                      'aria-label': 'change date',
                                    }}
                                    showTodayButton
                                    fullWidth
                                    minDate={
                                      watch(
                                        `InvoiceItems.${index}.ContractStartDate`
                                      ) ||
                                      new Date(
                                        latestOpenPeriodCheckingDate?.StartDate
                                      )
                                    }
                                    maxDate={
                                      new Date(
                                        latestOpenPeriodCheckingDate?.EndDate
                                      )
                                    }
                                    InputProps={{
                                      className: 'date-input',
                                    }}
                                    disabled={disabled}
                                  />
                                )}
                              />
                            </MuiPickersUtilsProvider>
                          </TableCell>
                          <TableCell className="responsive-table-cell date-cell">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Controller
                                name={`InvoiceItems.${index}.FirstAmortDate`}
                                control={control}
                                defaultValue={new Date()}
                                render={({ value, onChange }) => (
                                  <KeyboardDatePicker
                                    format="dd/MM/yyyy"
                                    value={value || new Date()}
                                    onChange={onChange}
                                    margin="none"
                                    allowKeyboardControl
                                    KeyboardButtonProps={{
                                      'aria-label': 'change date',
                                    }}
                                    showTodayButton
                                    fullWidth
                                    minDate={watch(
                                      `InvoiceItems.${index}.ContractStartDate`
                                    )}
                                    InputProps={{
                                      className: 'date-input',
                                    }}
                                    disabled={disabled}
                                  />
                                )}
                              />
                            </MuiPickersUtilsProvider>
                          </TableCell>
                          <TableCell className="responsive-table-cell months-cell">
                            <TextField
                              value={itemMonths}
                              disabled
                              fullWidth
                              margin="none"
                              inputProps={{
                                className: 'date-input text-center',
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}

          <Grid spacing={1} container style={{ textAlign: 'center' }}>
            <Grid item xs={12}>
              <Button
                type="reset"
                style={{
                  backgroundColor: Object.values(selectedItems).some(v => v)
                    ? 'orange'
                    : '#e5e5e5',
                  width: '140px',
                  color: Object.values(selectedItems).some(v => v)
                    ? 'white'
                    : '#a7a7a7',
                }}
                variant="contained"
                disabled={!Object.values(selectedItems).some(v => v)}
                onClick={() => {
                  handleSubmit(data => onSubmitGenerate(data))()
                }}
              >
                Generate
              </Button>
            </Grid>
          </Grid>

          <div style={{ paddingBottom: '45px' }} />
        </CardContents>

        {getGenerateAmortisation?.map((x, index) => {
          return (
            <>
              <List className="core-list" style={{ paddingBottom: '0px' }}>
                <CardExpansion
                  customColor
                  className="space"
                  backColor={'#fff4dc'}
                  backPanelColor="#fff4dc"
                  summary={
                    <ListItem
                      key={index}
                      style={{ backgroundColor: '#fff4dc' }}
                    >
                      <ListItemText
                        primary={
                          <>
                            <span className={`c-orange xsTitle flex-space`}>
                              {x?.DebitMasterCOACode}
                            </span>
                            <span
                              style={{
                                color: 'orange',
                                fontSize: '12px',
                              }}
                            >
                              {amtStr(x?.DocAmt)}
                            </span>
                          </>
                        }
                        secondary={
                          <>
                            <span className={`desc flex-space`}>
                              {x?.DebitMasterCOAName}
                            </span>
                          </>
                        }
                      />
                    </ListItem>
                  }
                >
                  <InvoiceAmortisationItemForm
                    listItem={x?.AmortisationItemDetails}
                    control={control}
                    index={index}
                    x={x}
                    register={register}
                    CompanyID={CompanyID}
                    setErrMessage={setErrMessage}
                    setErrDialog={setErrDialog}
                    editData={editData}
                    setValue={setValue}
                    errors={errors}
                    watch={watch}
                    mode={mode}
                    isErrorCall={isErrorCall}
                  />
                </CardExpansion>
              </List>
            </>
          )
        })}

        {footerOptions?.length > 0 && (
          <AccountFooter options={[...footerOptions]} />
        )}
      </ContentWrapper>
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
